export function getRectFromPoints(points) {
  const normalized = points
    .map((p) => ({
      x: Number(p.x),
      y: Number(p.y),
    }))
    .filter((p) => Number.isFinite(p.x) && Number.isFinite(p.y));
  if (normalized.length < 4) return null;

  const xList = normalized.map((p) => p.x);
  const yList = normalized.map((p) => p.y);
  const minX = Math.min(...xList);
  const maxX = Math.max(...xList);
  const minY = Math.min(...yList);
  const maxY = Math.max(...yList);

  return {
    x: minX,
    y: minY,
    width: Math.max(0, maxX - minX),
    height: Math.max(0, maxY - minY),
  };
}

export function getRectByPayload(points, faceCoords) {
  // 1) 优先解析后端的一维数组坐标
  const rectFromArray = getRectFromFaceCoords(faceCoords);
  if (rectFromArray) return rectFromArray;

  // 2) 兼容旧格式：4个点对象
  return getRectFromPoints(points);
}

// 支持两种格式：
// [x, y, h, w] => 左上、长方形高宽（当前后端定义）
// [x1, y1, x2, y2, x3, y3, x4, y4] => 四个点
function getRectFromFaceCoords(faceCoords) {
  if (!Array.isArray(faceCoords) || faceCoords.length < 4) {
    return null;
  }

  const normalized = faceCoords
    .map((v) => Number(String(v).replace(/\s+/g, "")))
    .filter((v) => Number.isFinite(v));

  if (normalized.length < 4) return null;

  if (normalized.length === 4) {
    const x = normalized[0];
    const y = normalized[1];
    const width = normalized[2];
    const height = normalized[3];

    return {
      x,
      y,
      width: Math.max(0, width),
      height: Math.max(0, height),
    };
  }

  if (normalized.length >= 8) {
    const xList = [];
    const yList = [];
    for (let i = 0; i < 8; i += 2) {
      xList.push(normalized[i]);
      yList.push(normalized[i + 1]);
    }
    const minX = Math.min(...xList);
    const maxX = Math.max(...xList);
    const minY = Math.min(...yList);
    const maxY = Math.max(...yList);
    return {
      x: minX,
      y: minY,
      width: Math.max(0, maxX - minX),
      height: Math.max(0, maxY - minY),
    };
  }

  return null;
}

// 按 object-fit: contain 的规则，把原图坐标映射到当前 video 渲染区域
export function mapRectToRenderArea(rect, sourceW, sourceH, renderW, renderH) {
  const sourceRatio = sourceW / sourceH;
  const renderRatio = renderW / renderH;
  let actualW = renderW;
  let actualH = renderH;
  let offsetX = 0;
  let offsetY = 0;
  if (sourceRatio > renderRatio) {
    actualW = renderW;
    actualH = renderW / sourceRatio;
    offsetY = (renderH - actualH) / 2;
  } else {
    actualH = renderH;
    actualW = renderH * sourceRatio;
    offsetX = (renderW - actualW) / 2;
  }
  const scaleX = actualW / sourceW;
  const scaleY = actualH / sourceH;
  return {
    left: rect.x * scaleX + offsetX,
    top: rect.y * scaleY + offsetY,
    width: rect.width * scaleX,
    height: rect.height * scaleY,
  };
}